import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { IAdminDocument } from "../../../../@types/documentAdmnstration.types";

const { post, get, del } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const adminInitialRoute = "admin/document";
const memberInitialRoute = "member";

const getUploadedDocumentList = async (filterQuery: any) => {
	try {
		// console.log("filterQuery", filterQuery);
		const endpoint = adminInitialRoute + "/get-document-list";
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filterQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const createFolder = async (payload: IAdminDocument) => {
	try {
		const endpoint = adminInitialRoute + "/create-folder";
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const adminDocumentUpload = async (_formData: FormData) => {
	try {
		const endpoint = `${adminInitialRoute}/upload-document`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, _formData, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const getMemberUploadedDocumentList = async (ssn: string, group_number: number) => {
	try {
		const endpoint = memberInitialRoute + `/get-uploaded-document/${ssn}/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const getMemberList = async (filterQuery: any, group_number: number) => {
	try {
		const endpoint = memberInitialRoute + `/get-all-member/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filterQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const adminShareFile = async (payload: any) => {
	try {
		const endpoint = adminInitialRoute + "/share";
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const adminShareFileToGroup = async (payload: any) => {
	try {
		const endpoint = adminInitialRoute + "/share-group";
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

const getGroupOwnerSharedDocumentMember = async (member_object_id: string) => {
	try {
		const endpoint = `${memberInitialRoute}/get-shared-document/${member_object_id}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const getFolderDocumentListMember = async (filter: any) => {
	try {
		const endpoint = `${memberInitialRoute}/get-folder-document/`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const deleteAdminDocument = async (documentId: string) => {
	try {
		const endpoint = `${adminInitialRoute}/delete-document/${documentId}`;
		const token = localStorage.getItem("@jwt");
		const response = await del(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.delete.succ) {
				alert("The Document is deleted successfully");
				return documentId;
			}
		}
		throw new Error();
	} catch (error) {
		throw error;
	}
};

export const documentSharing = {
	createFolder,
	getUploadedDocumentList,
	adminDocumentUpload,
	getMemberUploadedDocumentList,
	getMemberList,
	adminShareFile,
	adminShareFileToGroup,
	getGroupOwnerSharedDocumentMember,
	getFolderDocumentListMember,
	deleteAdminDocument
};
